import { render } from "./InputfieldComp.vue?vue&type=template&id=bc8f54aa"
import script from "./InputfieldComp.vue?vue&type=script&lang=js"
export * from "./InputfieldComp.vue?vue&type=script&lang=js"

import "./InputfieldComp.vue?vue&type=style&index=0&id=bc8f54aa&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__